import { useQuery, useMutation } from '@tanstack/react-query';
import clientPortalAxiosInstance from '../../common/utilities/axios/clientPortalAxiosInstance';
import sleep from 'sleep-promise';

export const useGetClientCodeListByClientAccountIdQuery = ({ clientAccountId }) => {
    return useQuery({
        queryKey: ['getClientCodeListByClientAccountIdQuery', clientAccountId],
        queryFn: () => {
            // sleep(2000);
            return clientPortalAxiosInstance
                .get(`/User-Profile/clientAccountCodes/${clientAccountId}`)
                .then((res) => res.data)
        },
        enabled: !!clientAccountId,
    })
}

export const useGetClientSubAccountByIdQuery = ({ clientSubAccountId }) => {
    return useQuery({
        queryKey: ['getClientSubAccountByIdQuery', clientSubAccountId],
        queryFn: () => {
            // sleep(2000);
            return clientPortalAxiosInstance
                .get(`/User-Profile/clientAccount/${clientSubAccountId}`)
                .then((res) => res.data)
        },
        enabled: !!clientSubAccountId,
    })
}
/**it gets only client users specific for ClientSubAccount*/
export const useGetClientUsersByClientSubAccountIdQuery = ({ clientSubAccountId }) => {
    return useQuery({
        queryKey: ['getClientUsersByClientSubAccountIdQuery', clientSubAccountId],
        queryFn: () => {
            // sleep(2000);
            return clientPortalAxiosInstance
                .get(`/User-Profile/clientSubAccountUsers/${clientSubAccountId}`)
                .then((res) => res.data)
        },
        enabled: !!clientSubAccountId,
    })
}

/**it includes client users from ClientSubAccount and its parent clientAccount */
export const useGetClientUsersIncludingParentUsersByClientSubAccountIdQuery = ({ clientSubAccountId }) => {
    return useQuery({
        queryKey: ['getClientUsersIncludingParentUsersByClientSubAccountIdQuery', clientSubAccountId],
        queryFn: () => {
            // sleep(2000);
            return clientPortalAxiosInstance
                .get(`/User-Profile/clientSubAccountTeam/${clientSubAccountId}`)
                .then((res) => res.data)
        },
        enabled: !!clientSubAccountId,
    })
}


/**Mutations */
export const useViewClientSubAccountListMutation = () => {
    return useMutation({
        mutationFn: ({ loggedInUserId, roleId, isEnterpriseAdmin }) => {
            return clientPortalAxiosInstance.post(`/User-Profile/rolebasedclientAllsubAccounts`, {
                "LoggedInUserId": loggedInUserId || "",
                "RoleId": roleId || "",
                "IsEnterpriseAdmin": isEnterpriseAdmin
            })
        },
    })
}

export const useCreateClientSubAccountMutation = () => {
    return useMutation({
        mutationFn: ({ body }) => {
            return clientPortalAxiosInstance.post(`/User-Profile/clientAccount/createClientAccount`, body)
        },
    })
}

/**
 * If you use PUT to upload file then you may use application/octet-stream as Content-Type. If you upload into Amazon S3 storage using multipart/formdata as Content-Type it will make your files (images, pdfs, documents) into text files with http header added on top. This will damage the content of the uploaded file. So use application/octet-stream when uploading binary files with PUT methods.
 */
export const useUploadLogoOfClientSubAccountMutation = () => {

    return useMutation({
        mutationFn: ({ file }) => {
            /**file is single file and not array of files */

            const formData = new FormData();
            formData.append('file', file)

            return clientPortalAxiosInstance.post(`/client-referral/account/uploadAccountLogo`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
        },
    })
}

export const useUpdateClientSubAccountByIdMutation = () => {
    return useMutation({
        mutationFn: ({ body, clientSubAccountId }) => {
            return clientPortalAxiosInstance.put(`/User-Profile/clientAccount/updateClientAccount/${clientSubAccountId}`, body)
        },
    })
}
export const useDeleteClientSubAccountByIdMutation = () => {
    return useMutation({
        mutationFn: ({ clientSubAccountId, isDeleteMode, isClientAccount, isActivateAll }) => {
            return clientPortalAxiosInstance.delete(`/User-Profile/clientAccount/deleteClientAccount/${clientSubAccountId}`, {
                data: {
                    "IsDeleteMode": isDeleteMode,
                    "IsClientAccount": isClientAccount,
                    "IsActivateAll": isActivateAll
                }
            })
        },
    })
}
